import { SensitiveText } from "@/components/common/Sensitive";
import { cn } from "@/lib/utils";

interface BookingReferenceProps {
  /** Focus order number (canonical booking key). */
  sourceId: string;
  /** Focus dossier / file number ("מס' תיק"), when linked. */
  fileId?: string | null;
  /** Class applied to the wrapping element. */
  className?: string;
  /** Class applied to the silenced file id (defaults to muted text). */
  fileClassName?: string;
}

/**
 * Render a booking's `source_id` and, when present, its Focus dossier `file_id`
 * as a secondary reference: `159614 / 1250675`. The file id is privacy-masked
 * and de-emphasized so the order number stays primary. The slash + file id are
 * omitted entirely when no dossier number is linked (e.g. pre-shipment).
 */
export function BookingReference({
  sourceId,
  fileId,
  className,
  fileClassName,
}: BookingReferenceProps) {
  return (
    <span className={className}>
      {sourceId}
      {fileId ? (
        <>
          <span aria-hidden className="px-1 text-muted-foreground opacity-60">
            /
          </span>
          <SensitiveText
            className={cn("text-muted-foreground", fileClassName)}
            value={fileId}
          />
        </>
      ) : null}
    </span>
  );
}
